import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineYoutube,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function SelfIntro() {
  return (
    <Container fluid className="home-about-section  container-fluid" id="about">
  <Container>
    <Row>
      <Col md={8} className="home-about-description">
        <h1 style={{ fontSize: "2.6em" }}>
          LET ME <span className="purple"> INTRODUCE </span> MYSELF
        </h1>
        <p className="home-about-body">
          I am a focused and enthusiastic developer with a keen interest in web development and software development. By having a comprehensive exposure to the underlying concepts and applying them vividly to various projects, my love for these domains came into being. I am a passionate individual who thrives to build and apply algorithms to solve real-world industry problems.
          <br />
          <br />
          My field of interest's are building new &nbsp;
          <i>
            <b className="purple">FULL STACK DEVELOPEMNT</b>
          </i>
          &nbsp;and also passionate about all things in &nbsp;
          <i>
            <b className="purple">BACKEND DEVELOPEMNT</b>
          </i>
          <br />
          <br />
          Whenever possible, I apply my passion for developing products with <b className="purple">Node.js</b> and modern JavaScript libraries and frameworks like <b className="purple">React.js and Next.js</b>. I am also proficient in classics like <i><b className="purple">Python, Java, and JavaScript.</b></i>
        </p>
      </Col>
      <Col md={4} className="myAvtar">
        <Tilt>
          <img src="https://umaajay.netlify.app/assets/img/profile.jpeg" className="img-fluid" alt="uma ajay" />
        </Tilt>
      </Col>
    </Row>
    <Row>
      <Col md={12} className="home-about-social">
        <h1>FIND ME ON</h1>
        <ul className="home-about-social-links">
      <li className="social-icons">
        <a
          href="https://github.com/umaajay"
          target="_blank"
          rel="noreferrer"
          className="icon-colour  home-social-icons"
        >
          <AiFillGithub />
        </a>
      </li>

      <li className="social-icons">
        <a
          href="https://www.linkedin.com/in/uma-ajay-kumar-reddy-p-s/"
          target="_blank"
          rel="noreferrer"
          className="icon-colour  home-social-icons"
        >
          <FaLinkedinIn />
        </a>
      </li>
      <li className="social-icons">
        <a
          href="https://www.instagram.com/umaajaykumarreddyp/"
          target="_blank"
          rel="noreferrer"
          className="icon-colour home-social-icons"
        >
          <AiFillInstagram />
        </a>
      </li>
      <li className="social-icons">
        <a
          href="https://www.youtube.com/channel/UCiq5JWYDxNumb20dLHRNXfA/videos"
          target="_blank"
          rel="noreferrer"
          className="icon-colour  home-social-icons"
        >
          <AiOutlineYoutube />
        </a>
      </li>
    </ul>
  </Col>
</Row>
</Container>
</Container>
  );
}
export default SelfIntro;
